import { default as awardsPT7PB8DUxjMeta } from "/opt/build/repo/src/pages/about/awards.vue?macro=true";
import { default as historyQ03bHzXvHoMeta } from "/opt/build/repo/src/pages/about/company/history.vue?macro=true";
import { default as missionBckBGgTkttMeta } from "/opt/build/repo/src/pages/about/company/mission.vue?macro=true";
import { default as companyrsxC0DazZ1Meta } from "/opt/build/repo/src/pages/about/company.vue?macro=true";
import { default as architectsMESu1suQ1zMeta } from "/opt/build/repo/src/pages/about/partners/architects.vue?macro=true";
import { default as contractorspGn0OMaOsSMeta } from "/opt/build/repo/src/pages/about/partners/contractors.vue?macro=true";
import { default as engineersxylXzpeRuOMeta } from "/opt/build/repo/src/pages/about/partners/engineers.vue?macro=true";
import { default as expeditersdyuUBrt90LMeta } from "/opt/build/repo/src/pages/about/partners/expediters.vue?macro=true";
import { default as inspectorsULxStYBxFXMeta } from "/opt/build/repo/src/pages/about/partners/inspectors.vue?macro=true";
import { default as surveyorsd1nPhGjzIWMeta } from "/opt/build/repo/src/pages/about/partners/surveyors.vue?macro=true";
import { default as partnersQOzSDlAuj8Meta } from "/opt/build/repo/src/pages/about/partners.vue?macro=true";
import { default as aboutm5RZo0AsoGMeta } from "/opt/build/repo/src/pages/about.vue?macro=true";
import { default as _91id_93NPXRDJKpN4Meta } from "/opt/build/repo/src/pages/admin/[id].vue?macro=true";
import { default as announcementxjJLtEcKmdMeta } from "/opt/build/repo/src/pages/admin/announcement.vue?macro=true";
import { default as createwuUuWlw2pSMeta } from "/opt/build/repo/src/pages/admin/create.vue?macro=true";
import { default as indexH8Bqk9kxJdMeta } from "/opt/build/repo/src/pages/admin/index.vue?macro=true";
import { default as adminG91UhNIpBvMeta } from "/opt/build/repo/src/pages/admin.vue?macro=true";
import { default as careersQUmIfX1MnLMeta } from "/opt/build/repo/src/pages/contact/careers.vue?macro=true";
import { default as call_45usYF5RKPuOBGMeta } from "/opt/build/repo/src/pages/contact/connect/call-us.vue?macro=true";
import { default as email_45usmxXDsPvL9SMeta } from "/opt/build/repo/src/pages/contact/connect/email-us.vue?macro=true";
import { default as visit_45usWhynJ7NZtxMeta } from "/opt/build/repo/src/pages/contact/connect/visit-us.vue?macro=true";
import { default as connectdjKy5wedbCMeta } from "/opt/build/repo/src/pages/contact/connect.vue?macro=true";
import { default as franchisingOWjc4594vvMeta } from "/opt/build/repo/src/pages/contact/franchising.vue?macro=true";
import { default as investor_45relationsnJcF52PUhhMeta } from "/opt/build/repo/src/pages/contact/investor-relations.vue?macro=true";
import { default as media_45inquiriesudP6NUeLEAMeta } from "/opt/build/repo/src/pages/contact/media-inquiries.vue?macro=true";
import { default as send_45rfp7mdM3x5XN0Meta } from "/opt/build/repo/src/pages/contact/send-rfp.vue?macro=true";
import { default as contactJXuhO4C6ARMeta } from "/opt/build/repo/src/pages/contact.vue?macro=true";
import { default as indexMUmX8mAfjNMeta } from "/opt/build/repo/src/pages/index.vue?macro=true";
import { default as loginwV8UxyWAwuMeta } from "/opt/build/repo/src/pages/login.vue?macro=true";
import { default as pricingzMP8KKUaopMeta } from "/opt/build/repo/src/pages/pricing.vue?macro=true";
import { default as commercialmdkLPec9WdMeta } from "/opt/build/repo/src/pages/projects/by-client/commercial.vue?macro=true";
import { default as residential1GvFItSjDoMeta } from "/opt/build/repo/src/pages/projects/by-client/residential.vue?macro=true";
import { default as by_45clientF0EtV8MSbnMeta } from "/opt/build/repo/src/pages/projects/by-client.vue?macro=true";
import { default as bronxkIe9zmGCUSMeta } from "/opt/build/repo/src/pages/projects/by-location/bronx.vue?macro=true";
import { default as brooklynqOuyOW2ofrMeta } from "/opt/build/repo/src/pages/projects/by-location/brooklyn.vue?macro=true";
import { default as manhattanTXBQxx3PYVMeta } from "/opt/build/repo/src/pages/projects/by-location/manhattan.vue?macro=true";
import { default as otherTuh0NG8F7YMeta } from "/opt/build/repo/src/pages/projects/by-location/other.vue?macro=true";
import { default as queenscuM4CcLgiVMeta } from "/opt/build/repo/src/pages/projects/by-location/queens.vue?macro=true";
import { default as staten_45islandWHIXBAsZnXMeta } from "/opt/build/repo/src/pages/projects/by-location/staten-island.vue?macro=true";
import { default as by_45locationvWWgPk9OvJMeta } from "/opt/build/repo/src/pages/projects/by-location.vue?macro=true";
import { default as completedc4C1OLx1XIMeta } from "/opt/build/repo/src/pages/projects/by-status/completed.vue?macro=true";
import { default as currentI2KWXZ2MiXMeta } from "/opt/build/repo/src/pages/projects/by-status/current.vue?macro=true";
import { default as by_45statusTinTIDlshSMeta } from "/opt/build/repo/src/pages/projects/by-status.vue?macro=true";
import { default as indexNrbRk3lXS6Meta } from "/opt/build/repo/src/pages/projects/featured/index.vue?macro=true";
import { default as featurednZNY5WyV9IMeta } from "/opt/build/repo/src/pages/projects/featured.vue?macro=true";
import { default as projectsfEVGZzBgwgMeta } from "/opt/build/repo/src/pages/projects.vue?macro=true";
import { default as architecturalsrVa0WAzMJMeta } from "/opt/build/repo/src/pages/services/architectural.vue?macro=true";
import { default as consultingjy9OD90eEBMeta } from "/opt/build/repo/src/pages/services/consulting.vue?macro=true";
import { default as expediting1zP8ZQTmUKMeta } from "/opt/build/repo/src/pages/services/expediting.vue?macro=true";
import { default as fire_45alarmugXaADVQiGMeta } from "/opt/build/repo/src/pages/services/fire-protection/fire-alarm.vue?macro=true";
import { default as sprinklerazzUgF7EctMeta } from "/opt/build/repo/src/pages/services/fire-protection/sprinkler.vue?macro=true";
import { default as standpipeFvJ1pSgRyHMeta } from "/opt/build/repo/src/pages/services/fire-protection/standpipe.vue?macro=true";
import { default as fire_45protectiondjETrsaLYlMeta } from "/opt/build/repo/src/pages/services/fire-protection.vue?macro=true";
import { default as progressHtNpe1pEjQMeta } from "/opt/build/repo/src/pages/services/inspections/progress.vue?macro=true";
import { default as special2YsTET7eQqMeta } from "/opt/build/repo/src/pages/services/inspections/special.vue?macro=true";
import { default as inspectionslVntdL0vlDMeta } from "/opt/build/repo/src/pages/services/inspections.vue?macro=true";
import { default as electricalxNQIponB89Meta } from "/opt/build/repo/src/pages/services/mep/electrical.vue?macro=true";
import { default as mechanicalsl770RcPSsMeta } from "/opt/build/repo/src/pages/services/mep/mechanical.vue?macro=true";
import { default as plumbingVR13ZbP6pcMeta } from "/opt/build/repo/src/pages/services/mep/plumbing.vue?macro=true";
import { default as mepuymrojEOnQMeta } from "/opt/build/repo/src/pages/services/mep.vue?macro=true";
import { default as structuralwhUgoo5dBmMeta } from "/opt/build/repo/src/pages/services/structural.vue?macro=true";
import { default as services3hnzzKlG3AMeta } from "/opt/build/repo/src/pages/services.vue?macro=true";
import { default as architectsG7FpRZ3AerMeta } from "/opt/build/repo/src/pages/team/architects.vue?macro=true";
import { default as consultants31P7Cbo19MMeta } from "/opt/build/repo/src/pages/team/consultants.vue?macro=true";
import { default as engineersh2dPeb24ujMeta } from "/opt/build/repo/src/pages/team/engineers.vue?macro=true";
import { default as inspectorsK4FUInYpvXMeta } from "/opt/build/repo/src/pages/team/inspectors.vue?macro=true";
import { default as principalsOjcqIIsnv8Meta } from "/opt/build/repo/src/pages/team/principals.vue?macro=true";
import { default as teamb2bcZkSnQbMeta } from "/opt/build/repo/src/pages/team.vue?macro=true";
export default [
  {
    name: aboutm5RZo0AsoGMeta?.name ?? "about",
    path: aboutm5RZo0AsoGMeta?.path ?? "/about",
    children: [
  {
    name: awardsPT7PB8DUxjMeta?.name ?? "about-awards",
    path: awardsPT7PB8DUxjMeta?.path ?? "awards",
    meta: awardsPT7PB8DUxjMeta || {},
    alias: awardsPT7PB8DUxjMeta?.alias || [],
    redirect: awardsPT7PB8DUxjMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/about/awards.vue").then(m => m.default || m)
  },
  {
    name: companyrsxC0DazZ1Meta?.name ?? "about-company",
    path: companyrsxC0DazZ1Meta?.path ?? "company",
    children: [
  {
    name: historyQ03bHzXvHoMeta?.name ?? "about-company-history",
    path: historyQ03bHzXvHoMeta?.path ?? "history",
    meta: historyQ03bHzXvHoMeta || {},
    alias: historyQ03bHzXvHoMeta?.alias || [],
    redirect: historyQ03bHzXvHoMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/about/company/history.vue").then(m => m.default || m)
  },
  {
    name: missionBckBGgTkttMeta?.name ?? "about-company-mission",
    path: missionBckBGgTkttMeta?.path ?? "mission",
    meta: missionBckBGgTkttMeta || {},
    alias: missionBckBGgTkttMeta?.alias || [],
    redirect: missionBckBGgTkttMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/about/company/mission.vue").then(m => m.default || m)
  }
],
    meta: companyrsxC0DazZ1Meta || {},
    alias: companyrsxC0DazZ1Meta?.alias || [],
    redirect: companyrsxC0DazZ1Meta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/about/company.vue").then(m => m.default || m)
  },
  {
    name: partnersQOzSDlAuj8Meta?.name ?? "about-partners",
    path: partnersQOzSDlAuj8Meta?.path ?? "partners",
    children: [
  {
    name: architectsMESu1suQ1zMeta?.name ?? "about-partners-architects",
    path: architectsMESu1suQ1zMeta?.path ?? "architects",
    meta: architectsMESu1suQ1zMeta || {},
    alias: architectsMESu1suQ1zMeta?.alias || [],
    redirect: architectsMESu1suQ1zMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/about/partners/architects.vue").then(m => m.default || m)
  },
  {
    name: contractorspGn0OMaOsSMeta?.name ?? "about-partners-contractors",
    path: contractorspGn0OMaOsSMeta?.path ?? "contractors",
    meta: contractorspGn0OMaOsSMeta || {},
    alias: contractorspGn0OMaOsSMeta?.alias || [],
    redirect: contractorspGn0OMaOsSMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/about/partners/contractors.vue").then(m => m.default || m)
  },
  {
    name: engineersxylXzpeRuOMeta?.name ?? "about-partners-engineers",
    path: engineersxylXzpeRuOMeta?.path ?? "engineers",
    meta: engineersxylXzpeRuOMeta || {},
    alias: engineersxylXzpeRuOMeta?.alias || [],
    redirect: engineersxylXzpeRuOMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/about/partners/engineers.vue").then(m => m.default || m)
  },
  {
    name: expeditersdyuUBrt90LMeta?.name ?? "about-partners-expediters",
    path: expeditersdyuUBrt90LMeta?.path ?? "expediters",
    meta: expeditersdyuUBrt90LMeta || {},
    alias: expeditersdyuUBrt90LMeta?.alias || [],
    redirect: expeditersdyuUBrt90LMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/about/partners/expediters.vue").then(m => m.default || m)
  },
  {
    name: inspectorsULxStYBxFXMeta?.name ?? "about-partners-inspectors",
    path: inspectorsULxStYBxFXMeta?.path ?? "inspectors",
    meta: inspectorsULxStYBxFXMeta || {},
    alias: inspectorsULxStYBxFXMeta?.alias || [],
    redirect: inspectorsULxStYBxFXMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/about/partners/inspectors.vue").then(m => m.default || m)
  },
  {
    name: surveyorsd1nPhGjzIWMeta?.name ?? "about-partners-surveyors",
    path: surveyorsd1nPhGjzIWMeta?.path ?? "surveyors",
    meta: surveyorsd1nPhGjzIWMeta || {},
    alias: surveyorsd1nPhGjzIWMeta?.alias || [],
    redirect: surveyorsd1nPhGjzIWMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/about/partners/surveyors.vue").then(m => m.default || m)
  }
],
    meta: partnersQOzSDlAuj8Meta || {},
    alias: partnersQOzSDlAuj8Meta?.alias || [],
    redirect: partnersQOzSDlAuj8Meta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/about/partners.vue").then(m => m.default || m)
  }
],
    meta: aboutm5RZo0AsoGMeta || {},
    alias: aboutm5RZo0AsoGMeta?.alias || [],
    redirect: aboutm5RZo0AsoGMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/about.vue").then(m => m.default || m)
  },
  {
    path: adminG91UhNIpBvMeta?.path ?? "/admin",
    children: [
  {
    name: _91id_93NPXRDJKpN4Meta?.name ?? "admin-id",
    path: _91id_93NPXRDJKpN4Meta?.path ?? ":id()",
    meta: _91id_93NPXRDJKpN4Meta || {},
    alias: _91id_93NPXRDJKpN4Meta?.alias || [],
    redirect: _91id_93NPXRDJKpN4Meta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/admin/[id].vue").then(m => m.default || m)
  },
  {
    name: announcementxjJLtEcKmdMeta?.name ?? "admin-announcement",
    path: announcementxjJLtEcKmdMeta?.path ?? "announcement",
    meta: announcementxjJLtEcKmdMeta || {},
    alias: announcementxjJLtEcKmdMeta?.alias || [],
    redirect: announcementxjJLtEcKmdMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/admin/announcement.vue").then(m => m.default || m)
  },
  {
    name: createwuUuWlw2pSMeta?.name ?? "admin-create",
    path: createwuUuWlw2pSMeta?.path ?? "create",
    meta: createwuUuWlw2pSMeta || {},
    alias: createwuUuWlw2pSMeta?.alias || [],
    redirect: createwuUuWlw2pSMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/admin/create.vue").then(m => m.default || m)
  },
  {
    name: indexH8Bqk9kxJdMeta?.name ?? "admin",
    path: indexH8Bqk9kxJdMeta?.path ?? "",
    meta: indexH8Bqk9kxJdMeta || {},
    alias: indexH8Bqk9kxJdMeta?.alias || [],
    redirect: indexH8Bqk9kxJdMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/admin/index.vue").then(m => m.default || m)
  }
],
    name: adminG91UhNIpBvMeta?.name ?? undefined,
    meta: adminG91UhNIpBvMeta || {},
    alias: adminG91UhNIpBvMeta?.alias || [],
    redirect: adminG91UhNIpBvMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/admin.vue").then(m => m.default || m)
  },
  {
    name: contactJXuhO4C6ARMeta?.name ?? "contact",
    path: contactJXuhO4C6ARMeta?.path ?? "/contact",
    children: [
  {
    name: careersQUmIfX1MnLMeta?.name ?? "contact-careers",
    path: careersQUmIfX1MnLMeta?.path ?? "careers",
    meta: careersQUmIfX1MnLMeta || {},
    alias: careersQUmIfX1MnLMeta?.alias || [],
    redirect: careersQUmIfX1MnLMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/contact/careers.vue").then(m => m.default || m)
  },
  {
    name: connectdjKy5wedbCMeta?.name ?? "contact-connect",
    path: connectdjKy5wedbCMeta?.path ?? "connect",
    children: [
  {
    name: call_45usYF5RKPuOBGMeta?.name ?? "contact-connect-call-us",
    path: call_45usYF5RKPuOBGMeta?.path ?? "call-us",
    meta: call_45usYF5RKPuOBGMeta || {},
    alias: call_45usYF5RKPuOBGMeta?.alias || [],
    redirect: call_45usYF5RKPuOBGMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/contact/connect/call-us.vue").then(m => m.default || m)
  },
  {
    name: email_45usmxXDsPvL9SMeta?.name ?? "contact-connect-email-us",
    path: email_45usmxXDsPvL9SMeta?.path ?? "email-us",
    meta: email_45usmxXDsPvL9SMeta || {},
    alias: email_45usmxXDsPvL9SMeta?.alias || [],
    redirect: email_45usmxXDsPvL9SMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/contact/connect/email-us.vue").then(m => m.default || m)
  },
  {
    name: visit_45usWhynJ7NZtxMeta?.name ?? "contact-connect-visit-us",
    path: visit_45usWhynJ7NZtxMeta?.path ?? "visit-us",
    meta: visit_45usWhynJ7NZtxMeta || {},
    alias: visit_45usWhynJ7NZtxMeta?.alias || [],
    redirect: visit_45usWhynJ7NZtxMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/contact/connect/visit-us.vue").then(m => m.default || m)
  }
],
    meta: connectdjKy5wedbCMeta || {},
    alias: connectdjKy5wedbCMeta?.alias || [],
    redirect: connectdjKy5wedbCMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/contact/connect.vue").then(m => m.default || m)
  },
  {
    name: franchisingOWjc4594vvMeta?.name ?? "contact-franchising",
    path: franchisingOWjc4594vvMeta?.path ?? "franchising",
    meta: franchisingOWjc4594vvMeta || {},
    alias: franchisingOWjc4594vvMeta?.alias || [],
    redirect: franchisingOWjc4594vvMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/contact/franchising.vue").then(m => m.default || m)
  },
  {
    name: investor_45relationsnJcF52PUhhMeta?.name ?? "contact-investor-relations",
    path: investor_45relationsnJcF52PUhhMeta?.path ?? "investor-relations",
    meta: investor_45relationsnJcF52PUhhMeta || {},
    alias: investor_45relationsnJcF52PUhhMeta?.alias || [],
    redirect: investor_45relationsnJcF52PUhhMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/contact/investor-relations.vue").then(m => m.default || m)
  },
  {
    name: media_45inquiriesudP6NUeLEAMeta?.name ?? "contact-media-inquiries",
    path: media_45inquiriesudP6NUeLEAMeta?.path ?? "media-inquiries",
    meta: media_45inquiriesudP6NUeLEAMeta || {},
    alias: media_45inquiriesudP6NUeLEAMeta?.alias || [],
    redirect: media_45inquiriesudP6NUeLEAMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/contact/media-inquiries.vue").then(m => m.default || m)
  },
  {
    name: send_45rfp7mdM3x5XN0Meta?.name ?? "contact-send-rfp",
    path: send_45rfp7mdM3x5XN0Meta?.path ?? "send-rfp",
    meta: send_45rfp7mdM3x5XN0Meta || {},
    alias: send_45rfp7mdM3x5XN0Meta?.alias || [],
    redirect: send_45rfp7mdM3x5XN0Meta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/contact/send-rfp.vue").then(m => m.default || m)
  }
],
    meta: contactJXuhO4C6ARMeta || {},
    alias: contactJXuhO4C6ARMeta?.alias || [],
    redirect: contactJXuhO4C6ARMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: indexMUmX8mAfjNMeta?.name ?? "index",
    path: indexMUmX8mAfjNMeta?.path ?? "/",
    meta: indexMUmX8mAfjNMeta || {},
    alias: indexMUmX8mAfjNMeta?.alias || [],
    redirect: indexMUmX8mAfjNMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: loginwV8UxyWAwuMeta?.name ?? "login",
    path: loginwV8UxyWAwuMeta?.path ?? "/login",
    meta: loginwV8UxyWAwuMeta || {},
    alias: loginwV8UxyWAwuMeta?.alias || [],
    redirect: loginwV8UxyWAwuMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/login.vue").then(m => m.default || m)
  },
  {
    name: pricingzMP8KKUaopMeta?.name ?? "pricing",
    path: pricingzMP8KKUaopMeta?.path ?? "/pricing",
    meta: pricingzMP8KKUaopMeta || {},
    alias: pricingzMP8KKUaopMeta?.alias || [],
    redirect: pricingzMP8KKUaopMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: projectsfEVGZzBgwgMeta?.name ?? "projects",
    path: projectsfEVGZzBgwgMeta?.path ?? "/projects",
    children: [
  {
    name: by_45clientF0EtV8MSbnMeta?.name ?? "projects-by-client",
    path: by_45clientF0EtV8MSbnMeta?.path ?? "by-client",
    children: [
  {
    name: commercialmdkLPec9WdMeta?.name ?? "projects-by-client-commercial",
    path: commercialmdkLPec9WdMeta?.path ?? "commercial",
    meta: commercialmdkLPec9WdMeta || {},
    alias: commercialmdkLPec9WdMeta?.alias || [],
    redirect: commercialmdkLPec9WdMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/projects/by-client/commercial.vue").then(m => m.default || m)
  },
  {
    name: residential1GvFItSjDoMeta?.name ?? "projects-by-client-residential",
    path: residential1GvFItSjDoMeta?.path ?? "residential",
    meta: residential1GvFItSjDoMeta || {},
    alias: residential1GvFItSjDoMeta?.alias || [],
    redirect: residential1GvFItSjDoMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/projects/by-client/residential.vue").then(m => m.default || m)
  }
],
    meta: by_45clientF0EtV8MSbnMeta || {},
    alias: by_45clientF0EtV8MSbnMeta?.alias || [],
    redirect: by_45clientF0EtV8MSbnMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/projects/by-client.vue").then(m => m.default || m)
  },
  {
    name: by_45locationvWWgPk9OvJMeta?.name ?? "projects-by-location",
    path: by_45locationvWWgPk9OvJMeta?.path ?? "by-location",
    children: [
  {
    name: bronxkIe9zmGCUSMeta?.name ?? "projects-by-location-bronx",
    path: bronxkIe9zmGCUSMeta?.path ?? "bronx",
    meta: bronxkIe9zmGCUSMeta || {},
    alias: bronxkIe9zmGCUSMeta?.alias || [],
    redirect: bronxkIe9zmGCUSMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/projects/by-location/bronx.vue").then(m => m.default || m)
  },
  {
    name: brooklynqOuyOW2ofrMeta?.name ?? "projects-by-location-brooklyn",
    path: brooklynqOuyOW2ofrMeta?.path ?? "brooklyn",
    meta: brooklynqOuyOW2ofrMeta || {},
    alias: brooklynqOuyOW2ofrMeta?.alias || [],
    redirect: brooklynqOuyOW2ofrMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/projects/by-location/brooklyn.vue").then(m => m.default || m)
  },
  {
    name: manhattanTXBQxx3PYVMeta?.name ?? "projects-by-location-manhattan",
    path: manhattanTXBQxx3PYVMeta?.path ?? "manhattan",
    meta: manhattanTXBQxx3PYVMeta || {},
    alias: manhattanTXBQxx3PYVMeta?.alias || [],
    redirect: manhattanTXBQxx3PYVMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/projects/by-location/manhattan.vue").then(m => m.default || m)
  },
  {
    name: otherTuh0NG8F7YMeta?.name ?? "projects-by-location-other",
    path: otherTuh0NG8F7YMeta?.path ?? "other",
    meta: otherTuh0NG8F7YMeta || {},
    alias: otherTuh0NG8F7YMeta?.alias || [],
    redirect: otherTuh0NG8F7YMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/projects/by-location/other.vue").then(m => m.default || m)
  },
  {
    name: queenscuM4CcLgiVMeta?.name ?? "projects-by-location-queens",
    path: queenscuM4CcLgiVMeta?.path ?? "queens",
    meta: queenscuM4CcLgiVMeta || {},
    alias: queenscuM4CcLgiVMeta?.alias || [],
    redirect: queenscuM4CcLgiVMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/projects/by-location/queens.vue").then(m => m.default || m)
  },
  {
    name: staten_45islandWHIXBAsZnXMeta?.name ?? "projects-by-location-staten-island",
    path: staten_45islandWHIXBAsZnXMeta?.path ?? "staten-island",
    meta: staten_45islandWHIXBAsZnXMeta || {},
    alias: staten_45islandWHIXBAsZnXMeta?.alias || [],
    redirect: staten_45islandWHIXBAsZnXMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/projects/by-location/staten-island.vue").then(m => m.default || m)
  }
],
    meta: by_45locationvWWgPk9OvJMeta || {},
    alias: by_45locationvWWgPk9OvJMeta?.alias || [],
    redirect: by_45locationvWWgPk9OvJMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/projects/by-location.vue").then(m => m.default || m)
  },
  {
    name: by_45statusTinTIDlshSMeta?.name ?? "projects-by-status",
    path: by_45statusTinTIDlshSMeta?.path ?? "by-status",
    children: [
  {
    name: completedc4C1OLx1XIMeta?.name ?? "projects-by-status-completed",
    path: completedc4C1OLx1XIMeta?.path ?? "completed",
    meta: completedc4C1OLx1XIMeta || {},
    alias: completedc4C1OLx1XIMeta?.alias || [],
    redirect: completedc4C1OLx1XIMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/projects/by-status/completed.vue").then(m => m.default || m)
  },
  {
    name: currentI2KWXZ2MiXMeta?.name ?? "projects-by-status-current",
    path: currentI2KWXZ2MiXMeta?.path ?? "current",
    meta: currentI2KWXZ2MiXMeta || {},
    alias: currentI2KWXZ2MiXMeta?.alias || [],
    redirect: currentI2KWXZ2MiXMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/projects/by-status/current.vue").then(m => m.default || m)
  }
],
    meta: by_45statusTinTIDlshSMeta || {},
    alias: by_45statusTinTIDlshSMeta?.alias || [],
    redirect: by_45statusTinTIDlshSMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/projects/by-status.vue").then(m => m.default || m)
  },
  {
    path: featurednZNY5WyV9IMeta?.path ?? "featured",
    children: [
  {
    name: indexNrbRk3lXS6Meta?.name ?? "projects-featured",
    path: indexNrbRk3lXS6Meta?.path ?? "",
    meta: indexNrbRk3lXS6Meta || {},
    alias: indexNrbRk3lXS6Meta?.alias || [],
    redirect: indexNrbRk3lXS6Meta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/projects/featured/index.vue").then(m => m.default || m)
  }
],
    name: featurednZNY5WyV9IMeta?.name ?? undefined,
    meta: featurednZNY5WyV9IMeta || {},
    alias: featurednZNY5WyV9IMeta?.alias || [],
    redirect: featurednZNY5WyV9IMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/projects/featured.vue").then(m => m.default || m)
  }
],
    meta: projectsfEVGZzBgwgMeta || {},
    alias: projectsfEVGZzBgwgMeta?.alias || [],
    redirect: projectsfEVGZzBgwgMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/projects.vue").then(m => m.default || m)
  },
  {
    name: services3hnzzKlG3AMeta?.name ?? "services",
    path: services3hnzzKlG3AMeta?.path ?? "/services",
    children: [
  {
    name: architecturalsrVa0WAzMJMeta?.name ?? "services-architectural",
    path: architecturalsrVa0WAzMJMeta?.path ?? "architectural",
    meta: architecturalsrVa0WAzMJMeta || {},
    alias: architecturalsrVa0WAzMJMeta?.alias || [],
    redirect: architecturalsrVa0WAzMJMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/services/architectural.vue").then(m => m.default || m)
  },
  {
    name: consultingjy9OD90eEBMeta?.name ?? "services-consulting",
    path: consultingjy9OD90eEBMeta?.path ?? "consulting",
    meta: consultingjy9OD90eEBMeta || {},
    alias: consultingjy9OD90eEBMeta?.alias || [],
    redirect: consultingjy9OD90eEBMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/services/consulting.vue").then(m => m.default || m)
  },
  {
    name: expediting1zP8ZQTmUKMeta?.name ?? "services-expediting",
    path: expediting1zP8ZQTmUKMeta?.path ?? "expediting",
    meta: expediting1zP8ZQTmUKMeta || {},
    alias: expediting1zP8ZQTmUKMeta?.alias || [],
    redirect: expediting1zP8ZQTmUKMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/services/expediting.vue").then(m => m.default || m)
  },
  {
    name: fire_45protectiondjETrsaLYlMeta?.name ?? "services-fire-protection",
    path: fire_45protectiondjETrsaLYlMeta?.path ?? "fire-protection",
    children: [
  {
    name: fire_45alarmugXaADVQiGMeta?.name ?? "services-fire-protection-fire-alarm",
    path: fire_45alarmugXaADVQiGMeta?.path ?? "fire-alarm",
    meta: fire_45alarmugXaADVQiGMeta || {},
    alias: fire_45alarmugXaADVQiGMeta?.alias || [],
    redirect: fire_45alarmugXaADVQiGMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/services/fire-protection/fire-alarm.vue").then(m => m.default || m)
  },
  {
    name: sprinklerazzUgF7EctMeta?.name ?? "services-fire-protection-sprinkler",
    path: sprinklerazzUgF7EctMeta?.path ?? "sprinkler",
    meta: sprinklerazzUgF7EctMeta || {},
    alias: sprinklerazzUgF7EctMeta?.alias || [],
    redirect: sprinklerazzUgF7EctMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/services/fire-protection/sprinkler.vue").then(m => m.default || m)
  },
  {
    name: standpipeFvJ1pSgRyHMeta?.name ?? "services-fire-protection-standpipe",
    path: standpipeFvJ1pSgRyHMeta?.path ?? "standpipe",
    meta: standpipeFvJ1pSgRyHMeta || {},
    alias: standpipeFvJ1pSgRyHMeta?.alias || [],
    redirect: standpipeFvJ1pSgRyHMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/services/fire-protection/standpipe.vue").then(m => m.default || m)
  }
],
    meta: fire_45protectiondjETrsaLYlMeta || {},
    alias: fire_45protectiondjETrsaLYlMeta?.alias || [],
    redirect: fire_45protectiondjETrsaLYlMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/services/fire-protection.vue").then(m => m.default || m)
  },
  {
    name: inspectionslVntdL0vlDMeta?.name ?? "services-inspections",
    path: inspectionslVntdL0vlDMeta?.path ?? "inspections",
    children: [
  {
    name: progressHtNpe1pEjQMeta?.name ?? "services-inspections-progress",
    path: progressHtNpe1pEjQMeta?.path ?? "progress",
    meta: progressHtNpe1pEjQMeta || {},
    alias: progressHtNpe1pEjQMeta?.alias || [],
    redirect: progressHtNpe1pEjQMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/services/inspections/progress.vue").then(m => m.default || m)
  },
  {
    name: special2YsTET7eQqMeta?.name ?? "services-inspections-special",
    path: special2YsTET7eQqMeta?.path ?? "special",
    meta: special2YsTET7eQqMeta || {},
    alias: special2YsTET7eQqMeta?.alias || [],
    redirect: special2YsTET7eQqMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/services/inspections/special.vue").then(m => m.default || m)
  }
],
    meta: inspectionslVntdL0vlDMeta || {},
    alias: inspectionslVntdL0vlDMeta?.alias || [],
    redirect: inspectionslVntdL0vlDMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/services/inspections.vue").then(m => m.default || m)
  },
  {
    name: mepuymrojEOnQMeta?.name ?? "services-mep",
    path: mepuymrojEOnQMeta?.path ?? "mep",
    children: [
  {
    name: electricalxNQIponB89Meta?.name ?? "services-mep-electrical",
    path: electricalxNQIponB89Meta?.path ?? "electrical",
    meta: electricalxNQIponB89Meta || {},
    alias: electricalxNQIponB89Meta?.alias || [],
    redirect: electricalxNQIponB89Meta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/services/mep/electrical.vue").then(m => m.default || m)
  },
  {
    name: mechanicalsl770RcPSsMeta?.name ?? "services-mep-mechanical",
    path: mechanicalsl770RcPSsMeta?.path ?? "mechanical",
    meta: mechanicalsl770RcPSsMeta || {},
    alias: mechanicalsl770RcPSsMeta?.alias || [],
    redirect: mechanicalsl770RcPSsMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/services/mep/mechanical.vue").then(m => m.default || m)
  },
  {
    name: plumbingVR13ZbP6pcMeta?.name ?? "services-mep-plumbing",
    path: plumbingVR13ZbP6pcMeta?.path ?? "plumbing",
    meta: plumbingVR13ZbP6pcMeta || {},
    alias: plumbingVR13ZbP6pcMeta?.alias || [],
    redirect: plumbingVR13ZbP6pcMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/services/mep/plumbing.vue").then(m => m.default || m)
  }
],
    meta: mepuymrojEOnQMeta || {},
    alias: mepuymrojEOnQMeta?.alias || [],
    redirect: mepuymrojEOnQMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/services/mep.vue").then(m => m.default || m)
  },
  {
    name: structuralwhUgoo5dBmMeta?.name ?? "services-structural",
    path: structuralwhUgoo5dBmMeta?.path ?? "structural",
    meta: structuralwhUgoo5dBmMeta || {},
    alias: structuralwhUgoo5dBmMeta?.alias || [],
    redirect: structuralwhUgoo5dBmMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/services/structural.vue").then(m => m.default || m)
  }
],
    meta: services3hnzzKlG3AMeta || {},
    alias: services3hnzzKlG3AMeta?.alias || [],
    redirect: services3hnzzKlG3AMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/services.vue").then(m => m.default || m)
  },
  {
    name: teamb2bcZkSnQbMeta?.name ?? "team",
    path: teamb2bcZkSnQbMeta?.path ?? "/team",
    children: [
  {
    name: architectsG7FpRZ3AerMeta?.name ?? "team-architects",
    path: architectsG7FpRZ3AerMeta?.path ?? "architects",
    meta: architectsG7FpRZ3AerMeta || {},
    alias: architectsG7FpRZ3AerMeta?.alias || [],
    redirect: architectsG7FpRZ3AerMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/team/architects.vue").then(m => m.default || m)
  },
  {
    name: consultants31P7Cbo19MMeta?.name ?? "team-consultants",
    path: consultants31P7Cbo19MMeta?.path ?? "consultants",
    meta: consultants31P7Cbo19MMeta || {},
    alias: consultants31P7Cbo19MMeta?.alias || [],
    redirect: consultants31P7Cbo19MMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/team/consultants.vue").then(m => m.default || m)
  },
  {
    name: engineersh2dPeb24ujMeta?.name ?? "team-engineers",
    path: engineersh2dPeb24ujMeta?.path ?? "engineers",
    meta: engineersh2dPeb24ujMeta || {},
    alias: engineersh2dPeb24ujMeta?.alias || [],
    redirect: engineersh2dPeb24ujMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/team/engineers.vue").then(m => m.default || m)
  },
  {
    name: inspectorsK4FUInYpvXMeta?.name ?? "team-inspectors",
    path: inspectorsK4FUInYpvXMeta?.path ?? "inspectors",
    meta: inspectorsK4FUInYpvXMeta || {},
    alias: inspectorsK4FUInYpvXMeta?.alias || [],
    redirect: inspectorsK4FUInYpvXMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/team/inspectors.vue").then(m => m.default || m)
  },
  {
    name: principalsOjcqIIsnv8Meta?.name ?? "team-principals",
    path: principalsOjcqIIsnv8Meta?.path ?? "principals",
    meta: principalsOjcqIIsnv8Meta || {},
    alias: principalsOjcqIIsnv8Meta?.alias || [],
    redirect: principalsOjcqIIsnv8Meta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/team/principals.vue").then(m => m.default || m)
  }
],
    meta: teamb2bcZkSnQbMeta || {},
    alias: teamb2bcZkSnQbMeta?.alias || [],
    redirect: teamb2bcZkSnQbMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/team.vue").then(m => m.default || m)
  }
]